import React, { useState, Dispatch, SetStateAction } from "react";
import { uuidv7 } from "uuidv7";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { AttachmentMetaDataAndKey } from "../AddCommentField/AddCommentField";
import {
  isValidUrl,
  tryConvertToCorrectUrl,
} from "../../../../helpers/textHelper";
import { showToast } from "../../../methods/showToast";
import AddLinksModal from "../../../modals/AddLinksModal/AddLinksModal";

interface AddContentProposalLinksModalProps {
  onClose: () => void;
  setAttachments: Dispatch<SetStateAction<AttachmentMetaDataAndKey[]>>;
}

export default function AddContentProposalLinksModal({
  onClose,
  setAttachments,
}: AddContentProposalLinksModalProps) {
  const [value, setValue] = useState("");

  const onConfirmClick = (links: string[]) => {
    const externalLinksAttachments: AttachmentMetaDataAndKey[] = links.map(
      (link) => ({
        attachment: {
          name: null,
          mimeType: null,
          externalUrl: link,
        },
        localUuid: uuidv7(),
      }),
    );

    externalLinksAttachments.forEach((link: AttachmentMetaDataAndKey) => {
      link.attachment.externalUrl =
        tryConvertToCorrectUrl(link.attachment.externalUrl ?? null) ??
        link.attachment.externalUrl;
    });

    let existsAtLeastOneErrorUrl = false;
    const lastUrlInvalid: string[] = [];
    externalLinksAttachments.map((link: AttachmentMetaDataAndKey) => {
      if (!isValidUrl(link.attachment.externalUrl ?? null)) {
        if (link.attachment.externalUrl) {
          lastUrlInvalid.push(link.attachment.externalUrl);
        }

        existsAtLeastOneErrorUrl = true;
      }
    });

    if (existsAtLeastOneErrorUrl) {
      showToast(
        "error",
        <IDHFormattedMessage id="ws_error" defaultMessage="Error" />,
        <IDHFormattedMessage id="ws_error_at_least_one_url_invalid" />,
      );

      lastUrlInvalid.forEach((externalUrl: string) => {
        showToast("error", null, externalUrl);
      });

      return;
    }

    setAttachments((prev) => [...prev, ...externalLinksAttachments]);
  };

  return (
    <AddLinksModal
      onClose={onClose}
      onConfirmClick={onConfirmClick}
      value={value}
      setValue={setValue}
    />
  );
}
